import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
const SvgIconHighLight = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M10.1874 5.542C10.48 4.58065 11.841 4.58065 12.1336 5.542L13.0597 8.58445C13.1584 8.90881 13.4122 9.16266 13.7366 9.26138L16.7791 10.1874C17.7404 10.48 17.7404 11.841 16.7791 12.1337L13.7366 13.0597C13.4122 13.1584 13.1584 13.4122 13.0597 13.7366L12.1336 16.7791C11.841 17.7404 10.48 17.7404 10.1874 16.7791L9.26134 13.7366C9.16262 13.4122 8.90877 13.1584 8.58441 13.0597L5.54194 12.1337C4.58058 11.841 4.58058 10.48 5.54194 10.1874L8.58441 9.26138C8.90877 9.16266 9.16262 8.90881 9.26134 8.58445L10.1874 5.542Z",
		fill: "#3B82F6"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M4.80565 2.98363C4.95781 2.33879 5.87555 2.33879 6.02771 2.98362L6.28644 4.08007C6.34106 4.31155 6.52181 4.49229 6.75329 4.54691L7.84974 4.80564C8.49457 4.9578 8.49457 5.87553 7.84974 6.02769L6.75329 6.28642C6.52181 6.34104 6.34106 6.52178 6.28644 6.75327L6.02771 7.84971C5.87555 8.49454 4.95781 8.49454 4.80565 7.84971L4.54692 6.75327C4.4923 6.52179 4.31156 6.34104 4.08008 6.28642L2.98363 6.0277C2.33879 5.87553 2.33879 4.9578 2.98363 4.80564L4.08007 4.54691C4.31156 4.49229 4.4923 4.31155 4.54692 4.08007L4.80565 2.98363Z",
		fill: "#3B82F6"
	})]
});
export default SvgIconHighLight;
